import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import { useInsertClaimMutation } from "AppQuries/claim/claim-management";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "core/Operations/toast";
const AddClaim = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addClaim,
    isPending,
    isError,
    error,
  } = useInsertClaimMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      code: 0,
      transactionId: "",
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      isActive: true,
      isApproval: true,
    },
    resolver: yupResolver(addClaimValidation),
  });

  const navigate = useNavigate();

  const { handleSubmit } = methods;
  
  const onSubmit = (payload) => {
    console.log(payload);
    addClaim(payload, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          toast.success("Claim Added Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.claim}${all_routes.claim_list}`);
          }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
     
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Claim Management</h4>
                    <h6>Add your claim </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Claim Data</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  {/* <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip title="Back" />}
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.claim}${all_routes.claim_list}`}
                    >
                      <i className="fas fa-reply me-2" /> Back
                    </Link>
                  </OverlayTrigger> */}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Claims</h4>
                    </div>
                    <div className="card-body">
                      <ClaimForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddClaim;
